import React, { forwardRef } from 'react';
import styled from 'styled-components';
import buttonStyles from './styles';

type AnchorButtonProps = {
  className?: string;
  children: React.ReactNode;
  size?: string;
  variant?: string;
  onClick?: () => void;
};

export const AnchorButton = forwardRef((props: AnchorButtonProps, ref) => {
  const { className, children, size = `medium`, variant = `primary`, ...buttonProps } = props;
  return (
    <StyledAnchor ref={ref} size={size} variant={variant} className={className} {...buttonProps}>
      {children}
    </StyledAnchor>
  );
});

const StyledAnchor = styled.a`
  ${buttonStyles}
`;
